export const PRIMARYCOLOR = {
  COLOR: '#31323d',
  OFFLINECOLOR: 'red',
  TEXTCOLOR: '#3ac182',
  TEXTALPHAMIN:'.59',
  TEXTALPHAMAX:'1',
  HOVERCOLOR: '#3ac182'
};
export const HEADING = {
  VSPACE: '10'
}
export const SPACEONE = '.5';



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/constants/constants.js